import { defineStore } from 'pinia'
import { ref } from 'vue'
import { dispatchShowMobileGuide, isMobileBrowser } from '@/utils/mobileLayout'

/** 全局登录弹层：叠加在当前页面之上，不替换 router-view */
export const useLoginModalStore = defineStore('loginModal', () => {
  const visible = ref(false)
  const force = ref(false)
  function open(opts = {}) {
    if (isMobileBrowser()) {
      dispatchShowMobileGuide()
      return
    }
    visible.value = true
    force.value = !!opts.force
    try {
      window.dispatchEvent(new CustomEvent('login-modal-visibility', { detail: { visible: true, force: force.value } }))
    } catch (_) {
      // ignore
    }
  }
  function close() {
    visible.value = false
    force.value = false
    try {
      window.dispatchEvent(new CustomEvent('login-modal-visibility', { detail: { visible: false, force: false } }))
    } catch (_) {
      // ignore
    }
  }
  function closeForce() {
    visible.value = false
    force.value = false
    try {
      window.dispatchEvent(new CustomEvent('login-modal-visibility', { detail: { visible: false, force: false } }))
    } catch (_) {
      // ignore
    }
  }
  return { visible, force, open, close, closeForce }
})
